import React from "react";
import {Route} from "react-router-dom";
import Hoc from "./hoc/hoc";

// import Social_network from "./containers/Social_network";
import SettingsUsers from "./containers/SettingsUsers";
import {ForceLogin} from "./containers/ForceLogin";
import { HomePage } from "./containers/Homepage";


const BaseRouter = () => (
  <Hoc>
    <Route exact path="/" component={HomePage}/>
    <Route exact path="/logout" component={ForceLogin} />
     <Route exact path="/settings/users" component={SettingsUsers} />
  </Hoc>
);

export default BaseRouter;


